/**
 * Prefer facility-scoped membership types. Fall back to legacy market-only
 * docs (no facility_id) when the facility catalogue has not been fanned out.
 */
export const filterMembershipTypesForFacility = (membershipTypes, { facilityId, marketId } = {}) => {
	if (!Array.isArray(membershipTypes) || !membershipTypes.length) return []

	const facilityScoped = facilityId
		? membershipTypes.filter((t) => t?.facility_id && String(t.facility_id) === String(facilityId))
		: []

	if (facilityScoped.length) return facilityScoped

	if (!marketId) return []

	return membershipTypes.filter(
		(t) =>
			String(t?.market_id) === String(marketId) &&
			(t?.facility_id == null || t?.facility_id === undefined || t?.facility_id === '')
	)
}

export const filterMembershipTypesForHousehold = (membershipTypes, household) => {
	if (!household) return []

	return filterMembershipTypesForFacility(membershipTypes, {
		facilityId: household.default_facility_id,
		marketId: household.market_id || household.default_market_id
	})
}
